<template>
  <div class="finance-page">
    <header class="hero-section">
      <div class="hero-text">
        <h1>Finance & Digital Currency Services</h1>
        <p class="hero-desc-main">
          Embrace the future of finance with cutting-edge digital currency solutions, blockchain technology, and expert financial management. We specialize in secure, innovative financial strategies to empower your investments.
        </p>
      </div>
    </header>

    <section class="service-overview fade-in-section">
      <div class="service-img">
        <img src="https://img.freepik.com/premium-photo/futuristic-financial-center-with-stock-market-dominated-by-digital-currencies-blockchain-holographic-charts-rising-amidst-crumbling-financial-data_1290280-1496.jpg" loading="eager" alt="Digital Finance" class="finance-img">
      </div>
      <div class="service-info">
        <h2>Our Expertise in Finance</h2>
        <p>
          At the forefront of the financial revolution, we provide comprehensive digital finance solutions, including cryptocurrency management, blockchain consulting, and innovative trading strategies. Trust us to guide you through the complexities of the modern financial landscape.
        </p>
      </div>
     
    </section>

    <div class="stats-section fade-in-section">
      <div class="stats-item">
        <div class="stats-heading">{{ animatedNumbers.projects }}+</div>
        <div class="stats-sub-heading">Digital Finance Projects Completed</div>
      </div>
      <div class="stats-item">
        <div class="stats-heading">{{ animatedNumbers.years }} Years</div>
        <div class="stats-sub-heading">In the Financial Industry</div>
      </div>
      <div class="stats-item">
        <div class="stats-heading">{{ animatedNumbers.rating }}<span class="star-rating">✭</span></div>
        <div class="stats-sub-heading">Client Satisfaction</div>
      </div>
    </div>

    <section class="services-section fade-in-section">
      <h2>Our Finance Services</h2>
      <div class="service-cards">
        <div class="service-card">
          <h3>Cryptocurrency Consulting</h3>
          <p>Get expert advice on cryptocurrency investments, blockchain technology, and trading strategies to secure your financial future.</p>
        </div>
        <div class="service-card">
          <h3>Blockchain Development</h3>
          <p>Implement cutting-edge blockchain solutions for secure, decentralized transactions and financial systems.</p>
        </div>
        <div class="service-card">
          <h3>Investment Strategies</h3>
          <p>Maximize your returns with custom-tailored investment strategies, leveraging modern financial tools and data analytics.</p>
        </div>
      </div>
    </section>

    <footer class="footer">
      <p>&copy; 2025 Digital Finance Experts. All Rights Reserved.</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Finance',
  data() {
    return {
      animatedNumbers: {
        projects: 0,
        years: 0,
        rating: 0,
      }
    };
  },
  mounted() {
    this.animateNumber('projects', 200, 2000);
    this.animateNumber('years', 10, 2500);
    this.animateNumber('rating', 5, 1000);
    this.observeSections();
  },
  methods: {
    animateNumber(ref, target, duration) {
      let start = this.animatedNumbers[ref];
      let stepTime = 16; 
      let step = (target - start) / (duration / stepTime);

      const updateNumber = () => {
        if (start < target) {
          start += step;
          this.animatedNumbers[ref] = Math.floor(start);
          requestAnimationFrame(updateNumber);
        } else {
          this.animatedNumbers[ref] = target;
        }
      };

      requestAnimationFrame(updateNumber);
    },
    observeSections() {
      const sections = document.querySelectorAll('.fade-in-section');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });

      sections.forEach(section => observer.observe(section));
    }
  }
};
</script>

<style scoped>
/* Initial state for fade-in animation */
.fade-in-section {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1s ease-out, transform 1s ease-out;
}

/* When element becomes active (in view) */
.fade-in-section.active {
  opacity: 1;
  transform: translateY(0);
}

/* Hero Section */
.hero-section {
  background-color: #42284a;
  padding: 60px 20px;
  text-align: center;
}

.hero-text h1 {
  font-size: 2.5rem;
  color: #FFF;
  margin-bottom: 20px;
  opacity: 0;
  animation: fadeInUp 1s 0.3s ease-out forwards;
}

.hero-desc-main {
  font-size: 1.2rem;
  color: #DDD;
  margin-bottom: 30px;
  opacity: 0;
  animation: fadeInUp 1s 0.6s ease-out forwards;
}

/* Finance Image */
.finance-img {
  width: 100%;
  max-height: 500px;
  object-fit: cover;
  border-radius: 10px;
  opacity: 0;
  animation: fadeInUp 1s 1s ease-out forwards;
}

/* Stats Section */
.stats-section {
  display: flex;
  justify-content: space-around;
  background-color: #2b2c38;
  padding: 40px 20px;
  color: white;
  text-align: center;
}

.stats-item {
  flex: 1;
  margin: 0 20px;
}

.stats-heading {
  font-size: 2rem;
  font-weight: bold;
}

.stats-sub-heading {
  font-size: 1rem;
  color: #d0d4c3;
}

/* Services Section */
.services-section {
  background-color: #f9f9f9;
  padding: 40px 20px;
  text-align: center;
}

.service-cards {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.service-card {
  background: #FFF;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
}

.service-card h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 10px;
}

.service-card p {
  color: #777;
  font-size: 1rem;
}
.service-info{
  padding: 8%;
    color: wheat;
}
/* Footer */
.footer {
  text-align: center;
  padding: 20px;
  background-color: #283E4A;
  color: white;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>
